import React from 'react';
import GroupSetActivityForm from './GroupSetActivityForm';

var GroupSetActivity = class extends React.Component {render()

  {
    const { updateLocationSetting, setting } = this.props;
    if (!setting) {
      return null;
    }

    return (
      <div className="nav-section-content-container" style={{ padding: 0 }}>
        <header className="nav-header">
          <div className="nav-section-header-title">
            <span>活动设置</span>
          </div>
        </header>
        <div className="kb-form-container">
          <fieldset className="fieldset">
            {/* <legend>租期时限</legend> */}
            <GroupSetActivityForm updateLocationSetting={updateLocationSetting} />
          </fieldset>
        </div>
      </div>);

  }};


export default GroupSetActivity;
